module.exports = __webpack_public_path__ + "img/1.de990e36.png";